export default "__VITE_ASSET__azlkggv1__"